import { render, staticRenderFns } from "./EditCategoryModal.vue?vue&type=template&id=c68613b6&"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports